export default __webpack_public_path__ + "sharp-sans-bold-subset-0f6cf50cce47e4e27b640b381b4050d1.bundle.woff2";